import { forwardRef, Children, createElement } from 'react';
const FixedContainer = (props, ref) => {
    const { children = [], style, items = [] } = props;
    return (createElement("div", { ref: ref, style: { position: 'relative', width: '100%', ...style } }, Children.map(children, (child, idx) => {
        return (createElement("div", { key: idx, style: { position: 'absolute', zIndex: idx, ...items[idx] } }, child));
    })));
};
FixedContainer.displayName = 'FixedContainer';
export default forwardRef(FixedContainer);
